import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { TemplateCornSchema } from '@eigtech/templates-types';
import { z } from 'zod';
import { DraftDocumentRecordSchema } from '../base/draftDocument.js';
import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
export const GenerateDraftDocumentPathSchema = z.object({
    entityId: ClaimV2CornSchema,
    templateId: TemplateCornSchema,
});
export const GenerateDraftDocumentHeadersSchema = ApiLambdalerAuthHeaderSchema;
export const GenerateDraftDocumentResponseSchema = DraftDocumentRecordSchema;
export const GenerateDraftDocumentRequestSchema = GenerateDraftDocumentPathSchema.merge(GenerateDraftDocumentHeadersSchema);
export const GenerateDraftDocumentApiSchema = {
    params: GenerateDraftDocumentPathSchema,
    headers: GenerateDraftDocumentHeadersSchema,
    response: GenerateDraftDocumentResponseSchema,
};
